<template>
  <div class="my-2">
    <v-row>
      <v-col cols="12" md="12">
        <v-card
          flat
          class="border-radius">
          <v-card-text class="py-0">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="#240087"
              slider-size="4">
              <v-tabs-slider color="#240087"></v-tabs-slider>
              <v-tab
                v-for="(item, index) in menu"
                :key="index"
                class="text-capitalize">
                <span class="body-2" :class="tab === index ? 'font-weight-bold color-default' : 'text-third'">
                  {{ item.label }}
                </span>
              </v-tab>
            </v-tabs>
            <v-divider/>
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="(item, index) in menu"
                :key="index">
                <router-view :model="tab"/>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tab: 0,
        // menu: []
        //   {
        //     label: "Kategori Item",
        //     value: "/master-pembelian/kategori-item"
        //   },
        //   {
        //     label: "Data Item",
        //     value: "/master-pembelian/item"
        //   },
        //   {
        //     label: "Data Supplier",
        //     value: "/master-pembelian/supplier"
        //   },
        //   // {
        //   //   label: "Data Item Supplier",
        //   //   value: "/master-pembelian/supplier-item"
        //   // },
        // ]
      }
    },
    components: {
      
    },
    computed: {
      menu () {
        let menu
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map((item, index) => {
          if(item.link === "/master") {
            // console.log(item.sub_menu)
            menu = item.sub_menu
          }
          // return item
        })
        // this.$router.push({ path: `${menu[0].link}` })
        // this.tab = 0
        return menu
      }
    },
    watch: {
      "tab": function(val) {
        this.$router.push({ path: `${this.menu[val].link}` })
      }
    },
    mounted () {
      if(this.$route.path === '/master') {
        this.$router.push({ path: `${this.menu[0].link}` })
      } 
      // this.tab = 0
      // console.log(this.menu.findIndex(item => item.link === this.$route.path))
      this.tab = this.$route.path === '/master' ? 0 : (this.menu.findIndex(item => item.link === this.$route.path))
      
    },
    methods: {
      
    }
  }
</script>